// downloadComposable.ts
export default async function download (response: any, templateFileName: string) {
  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", templateFileName) // Access the value from ref
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link) // Clean up the link element
}
